import { IMAGES } from './site';

export const SERVICE_PAGES = {
  'heating-air-conditioning': {
    seoTitle: 'Heating & Air Conditioning Services in Stanfield, NC | B.E. Holbrooks Co.',
    metaDescription: 'Need HVAC service in Stanfield, NC? B.E. Holbrooks Co. provides heating, air conditioning, HVAC repair, replacement, maintenance, and indoor air quality services. Call 704-888-2411.',
    h1: 'Heating & Air Conditioning Services in Stanfield, NC',
    eyebrow: 'Heating & Air',
    heroImage: IMAGES.techAmericanStandard,
    heroAlt: 'B.E. Holbrooks Co. technician servicing an American Standard Platinum air conditioning system in Stanfield, NC',
    serviceName: 'Heating & Air Conditioning',
    intro: [
      'For over 60 years, B.E. Holbrooks Co. has kept homes and businesses comfortable across Stanfield, Locust, Charlotte, Concord, Kannapolis, Monroe, Albemarle, Norwood, Gastonia, and Huntersville. As an American Standard Customer Care Dealer, we pair proven equipment with trained technicians who take the time to listen, evaluate, and solve the problem the right way.',
      'Whether you need a fast AC repair in July, a full HVAC replacement, routine maintenance, or a complete comfort system for new construction, our team handles every stage — from honest recommendations to clean, careful installation.',
    ],
    sections: [
      {
        h2: 'AC Repair & Service',
        body: [
          'When your air conditioner stops cooling, blows warm air, or runs nonstop, our technicians diagnose the real cause — not just the symptom. We service all major brands and arrive with the tools and parts to complete most AC repairs in a single visit.',
        ],
        bullets: ['Fast, accurate diagnostics', 'All major makes and models serviced', 'Straightforward pricing before work begins', 'Emergency comfort concerns prioritized'],
        link: { label: 'Learn more about AC repair', path: '/air-conditioning-repair-stanfield-nc' },
      },
      {
        h2: 'HVAC Replacement & Installation',
        body: [
          'If your system is over 12 to 15 years old, needs frequent repairs, or struggles to keep up, replacement may be the smarter investment. We size every system correctly for your home, install high-efficiency American Standard equipment, and walk you through available financing options.',
        ],
        bullets: ['Proper load calculation and system sizing', 'Energy-efficient American Standard systems', 'Financing options available', 'Free replacement estimates'],
        link: { label: 'Explore AC installation & replacement', path: '/air-conditioning-installation-stanfield-nc' },
      },
      {
        h2: 'Heating Repair & Replacement',
        body: [
          'From furnaces to heat pumps, we keep your family warm through every North Carolina cold snap. Our heating services cover repair, replacement, seasonal maintenance, and honest advice about whether to repair or replace an aging system.',
        ],
        link: { label: 'See heating repair & installation services', path: '/heating-repair-installation-stanfield-nc' },
      },
      {
        h2: 'Heat Pump Service',
        body: [
          'Heat pumps are one of the most efficient ways to heat and cool a home in our climate. We install, repair, and maintain heat pump systems and can help you decide if a high-efficiency heat pump is right for your home and energy bills.',
        ],
      },
      {
        h2: 'Indoor Air Quality Solutions',
        body: [
          'Comfort is more than temperature. We install whole-home air purification, upgraded filtration, and humidity control solutions that help your family breathe cleaner, healthier air year-round.',
        ],
        link: { label: 'Explore indoor air quality options', path: '/indoor-air-quality' },
      },
      {
        h2: 'Commercial HVAC Services',
        body: [
          'We design, install, and service heating and cooling systems for offices, retail spaces, churches, and light commercial buildings. Dependable comfort keeps your employees productive and your customers comfortable — and our team minimizes downtime when problems arise.',
        ],
      },
      {
        h2: 'New Construction HVAC',
        body: [
          'Building a custom home or commercial space? We work directly with homeowners, builders, and contractors to design and install complete HVAC systems for new construction — sized right, ducted right, and built to last.',
        ],
      },
    ],
    faqs: [
      { q: 'How often should I service my HVAC system?', a: 'We recommend professional maintenance twice a year — once in spring for your air conditioning and once in fall for your heating system. Regular tune-ups catch small problems early, keep efficiency high, and extend the life of your equipment.' },
      { q: 'Should I repair or replace my HVAC system?', a: 'As a general rule, if your system is over 12 years old, uses R-22 refrigerant, or the repair cost approaches half the price of a new system, replacement usually makes more financial sense. Our technicians will always give you an honest assessment of both options.' },
      { q: 'Do you service both heating and air conditioning systems?', a: 'Yes. B.E. Holbrooks Co. services furnaces, heat pumps, air conditioners, and complete HVAC systems from all major manufacturers — and we are an American Standard Customer Care Dealer for new installations.' },
      { q: 'Do you install energy-efficient HVAC systems?', a: 'Absolutely. We install high-efficiency American Standard air conditioners, heat pumps, and furnaces that can significantly lower your monthly energy bills while improving comfort. We will explain efficiency ratings in plain language so you can choose with confidence.' },
      { q: 'Do you provide HVAC service near Charlotte, NC?', a: 'Yes. We serve the entire greater Charlotte area including Charlotte, Concord, Kannapolis, Huntersville, Gastonia, and Monroe — plus our home communities of Stanfield, Locust, Albemarle, and Norwood.' },
      { q: 'Do you offer estimates for new HVAC systems?', a: 'Yes, we provide free, no-pressure estimates on system replacement and new installation. Call 704-888-2411 or request an estimate online and we will schedule a comfort consultation at your home or business.' },
    ],
  },

  'air-conditioning-repair-stanfield-nc': {
    seoTitle: 'AC Repair in Stanfield, NC | Air Conditioning Service | B.E. Holbrooks Co.',
    metaDescription: 'B.E. Holbrooks Co. provides AC repair and air conditioning service in Stanfield, Locust, Charlotte, Concord, Monroe, and nearby NC areas. Call 704-888-2411.',
    h1: 'AC Repair in Stanfield, NC',
    eyebrow: 'Air Conditioning Repair',
    heroImage: IMAGES.techGauges,
    heroAlt: 'B.E. Holbrooks Co. technician performing AC repair with refrigerant gauges in Stanfield, NC',
    serviceName: 'AC Repair',
    intro: [
      'When your air conditioner fails during a North Carolina summer, you need a local team that responds fast and fixes it right the first time. B.E. Holbrooks Co. has provided air conditioning repair in Stanfield and surrounding communities for over 60 years, and our technicians service all major makes and models.',
      'From refrigerant issues and frozen coils to thermostats and airflow problems, we diagnose the true cause of the breakdown, explain your options in plain language, and get your home cooling again — usually in a single visit.',
    ],
    sections: [
      {
        h2: 'Fast AC Diagnostics',
        body: [
          'A proper repair starts with a proper diagnosis. Our technicians test refrigerant pressures, electrical components, airflow, and thermostat communication to pinpoint exactly why your system is down — so you never pay for guesswork or parts you do not need.',
        ],
      },
      {
        h2: 'Common AC Problems We Fix',
        body: ['Some of the most frequent air conditioning issues we repair across Stanfield, Locust, and the greater Charlotte area include:'],
        bullets: [
          'System running but not cooling the home',
          'Warm air blowing from supply vents',
          'Refrigerant leaks and low refrigerant charge',
          'Frozen evaporator coils',
          'Weak or uneven airflow between rooms',
          'Thermostat malfunctions and short cycling',
          'Strange noises, odors, or water around the unit',
        ],
      },
      {
        h2: 'Refrigerant Issues',
        body: [
          'Low refrigerant almost always means a leak. Simply "topping off" the system is a short-term patch that costs you more over time. We locate and repair leaks properly, then recharge your system to manufacturer specifications. If your older system uses phased-out R-22 refrigerant, we will walk you through your repair and replacement options honestly.',
        ],
      },
      {
        h2: 'Airflow & Ductwork Problems',
        body: [
          'Hot spots, weak airflow, and dusty rooms often trace back to duct leaks, blocked returns, or a failing blower motor rather than the AC unit itself. We evaluate the whole system — not just the outdoor unit — to restore balanced, efficient cooling throughout your home.',
        ],
      },
      {
        h2: 'Emergency Comfort Concerns',
        body: [
          'A broken air conditioner is more than uncomfortable for families with young children, elderly relatives, or health concerns. When the heat is dangerous, call 704-888-2411 and tell us it is urgent — we prioritize emergency comfort calls across our Stanly County and Charlotte-area service territory.',
        ],
      },
      {
        h2: 'When to Repair vs. Replace Your AC',
        body: [
          'We will never push a replacement you do not need. But if your system is over 12 to 15 years old, breaks down repeatedly, or needs a major component like a compressor, investing in a new high-efficiency system often costs less over the next five years than continued repairs. We give you the numbers for both paths and let you decide.',
        ],
        link: { label: 'Compare AC replacement options', path: '/air-conditioning-installation-stanfield-nc' },
      },
    ],
    faqs: [
      { q: 'Why is my AC running but not cooling?', a: 'The most common causes are low refrigerant from a leak, a dirty condenser coil, a failed capacitor, or a frozen evaporator coil. Each has a different fix, which is why a proper diagnostic matters. Our technicians will find the exact cause and quote the repair before any work begins.' },
      { q: 'How much does AC repair cost in Stanfield, NC?', a: 'Repair costs depend on the failed component — a capacitor or contactor is relatively inexpensive, while a compressor or coil is a major repair. We provide straightforward, upfront pricing after diagnosis so there are never surprises on the invoice.' },
      { q: 'Do you repair all AC brands?', a: 'Yes. While we are an American Standard Customer Care Dealer for new installations, our technicians repair and service all major air conditioning brands including Trane, Carrier, Lennox, Goodman, Rheem, and more.' },
      { q: 'How fast can you get to my home?', a: 'We are based right in Stanfield, so we can often provide same-day service in Stanfield, Locust, Albemarle, and Norwood, and fast scheduling across Charlotte, Concord, Kannapolis, Monroe, Gastonia, and Huntersville.' },
      { q: 'Should I turn my AC off if it freezes up?', a: 'Yes. If you see ice on the refrigerant lines or the indoor coil, turn the system off and let it thaw completely — running it frozen can damage the compressor. Then call us at 704-888-2411 to find out why it froze in the first place.' },
    ],
  },

  'air-conditioning-installation-stanfield-nc': {
    seoTitle: 'AC Installation & Replacement in Stanfield, NC | B.E. Holbrooks Co.',
    metaDescription: 'Upgrade your cooling system with AC installation and replacement from B.E. Holbrooks Co. Serving Stanfield, Locust, Charlotte, Concord, Monroe, and surrounding areas.',
    h1: 'AC Installation & Replacement in Stanfield, NC',
    eyebrow: 'AC Installation',
    heroImage: IMAGES.techAmericanStandard,
    heroAlt: 'B.E. Holbrooks Co. technician installing a new American Standard Platinum air conditioning system in Stanfield, NC',
    serviceName: 'AC Installation & Replacement',
    intro: [
      'A new air conditioning system is one of the biggest comfort investments you will make in your home — and doing it right matters. B.E. Holbrooks Co. has installed cooling systems across Stanfield, Locust, Charlotte, and surrounding communities for over 60 years, and we treat every installation like it is going in our own home.',
      'As an American Standard Customer Care Dealer, we install equipment known for reliability and efficiency, size it correctly for your home, and back the job with the workmanship that has kept our customers coming back for generations.',
    ],
    sections: [
      {
        h2: 'New AC Installation Done Right',
        body: [
          'The best equipment installed poorly will never perform. Our installation process covers every detail: removing and disposing of your old system, setting the new equipment level and secure, brazing and pressure-testing refrigerant lines, verifying airflow, and commissioning the system to manufacturer specifications before we leave.',
        ],
      },
      {
        h2: 'Proper System Sizing Matters',
        body: [
          'Bigger is not better in air conditioning. An oversized system short-cycles, leaves humidity in the air, and wears out early. An undersized system runs constantly and never catches up. We perform a proper load calculation for your home — accounting for square footage, insulation, windows, and ductwork — so your new system is sized exactly right.',
        ],
      },
      {
        h2: 'Energy-Efficient Comfort Systems',
        body: [
          'Today\'s high-efficiency air conditioners and heat pumps use dramatically less electricity than systems installed even a decade ago. We will explain SEER2 ratings in plain terms, compare operating costs, and help you choose the efficiency level that delivers the best payback for your home and budget.',
        ],
        bullets: ['High-efficiency American Standard air conditioners', 'Two-stage and variable-speed options for even comfort', 'Heat pump systems for efficient heating and cooling', 'Smart thermostat compatibility'],
      },
      {
        h2: 'Your Comfort Consultation',
        body: [
          'Every replacement starts with a free in-home consultation. We inspect your current system and ductwork, listen to your comfort concerns — hot rooms, humidity, noise, energy bills — and present clear options at different price points. No pressure, no gimmicks, just honest recommendations.',
        ],
      },
      {
        h2: 'Financing Options Available',
        body: [
          'A new comfort system should not strain your budget. We offer financing options for qualified homeowners that let you spread the investment into manageable monthly payments — often offset by lower energy bills from your new efficient system.',
        ],
        link: { label: 'Learn about HVAC financing', path: '/financing' },
      },
      {
        h2: 'Replacing an Aging HVAC System',
        body: [
          'If your system is over 12 to 15 years old, uses R-22 refrigerant, or needs a compressor or coil, replacement usually beats repair on long-term cost. We will show you the comparison honestly — and if a repair still makes sense, we will tell you that too.',
        ],
        link: { label: 'Need a repair instead?', path: '/air-conditioning-repair-stanfield-nc' },
      },
    ],
    faqs: [
      { q: 'How long does AC installation take?', a: 'Most residential AC replacements are completed in one day. If ductwork modifications or a new line set are needed, we will tell you upfront and keep the disruption to your household as short as possible.' },
      { q: 'What size air conditioner do I need?', a: 'It depends on far more than square footage — insulation, window area, ceiling height, and ductwork all matter. That is why we perform a load calculation rather than guessing. Proper sizing is the single biggest factor in comfort and system life.' },
      { q: 'Do you install American Standard systems?', a: 'Yes. We were hand-picked by American Standard as a Customer Care Dealer, which means our installers are factory-trained on their equipment and our customers get access to some of the most dependable comfort systems made.' },
      { q: 'Can I finance a new AC system?', a: 'Yes, financing is available for qualified homeowners. Many customers find the monthly payment is largely offset by energy savings from a high-efficiency system. Call 704-888-2411 and we will walk you through the options.' },
      { q: 'Do you remove the old equipment?', a: 'Yes. Every installation includes safe removal and proper disposal of your old air conditioner, including refrigerant recovery handled to EPA standards.' },
    ],
  },

  'heating-repair-installation-stanfield-nc': {
    seoTitle: 'Heating Repair & Installation in Stanfield, NC | B.E. Holbrooks Co.',
    metaDescription: 'B.E. Holbrooks Co. provides heating repair, heating installation, furnace service, and heat pump service in Stanfield, NC and nearby areas. Call 704-888-2411.',
    h1: 'Heating Repair & Installation in Stanfield, NC',
    eyebrow: 'Heating Services',
    heroImage: IMAGES.heroTech,
    heroAlt: 'Heating repair and furnace installation service in Stanfield, NC',
    serviceName: 'Heating Repair & Installation',
    intro: [
      'North Carolina winters may be milder than up north, but when temperatures drop into the twenties, a reliable heating system is not a luxury — it is a necessity. B.E. Holbrooks Co. has provided heating repair and installation across Stanfield and the surrounding region for over 60 years.',
      'Whether you heat with a furnace, a heat pump, or a dual-fuel system, our trained technicians keep your home warm, safe, and efficient all winter long.',
    ],
    sections: [
      {
        h2: 'Heating Repair',
        body: [
          'No heat, uneven heat, strange smells, or a system that cycles on and off constantly — our technicians diagnose heating problems quickly and repair them correctly. We service all major brands of furnaces and heat pumps and carry common parts on our trucks to complete most repairs in one visit.',
        ],
        bullets: ['No-heat and emergency comfort calls prioritized', 'Ignition, blower, and control board repairs', 'All makes and models serviced', 'Upfront pricing before work begins'],
      },
      {
        h2: 'Heating Replacement & Installation',
        body: [
          'When repair no longer makes sense, we install high-efficiency American Standard furnaces and heat pumps sized precisely for your home. Every installation includes a full safety check, proper venting verification, and a walkthrough of your new system and thermostat.',
        ],
      },
      {
        h2: 'Furnace Service & Safety',
        body: [
          'Gas furnaces are dependable, but they burn fuel — which makes safety checks essential. Our heating service includes heat exchanger inspection, carbon monoxide testing, burner cleaning, and verification of all safety controls, so your family stays warm and protected.',
        ],
      },
      {
        h2: 'Heat Pump Repair & Replacement',
        body: [
          'Heat pumps handle both heating and cooling, which makes them the hardest-working system in your home. We repair defrost issues, refrigerant problems, and auxiliary heat failures — and when it is time, we install modern cold-climate-capable heat pumps that heat efficiently even on the coldest Carolina nights.',
        ],
      },
      {
        h2: 'Winter Maintenance',
        body: [
          'A fall tune-up is the cheapest insurance against a mid-winter breakdown. Our maintenance visits include cleaning, testing, and adjusting your heating system so it runs safely and efficiently through the season — and catches small issues before they become no-heat emergencies.',
        ],
      },
      {
        h2: 'Energy-Efficient Heating Options',
        body: [
          'If your heating bills keep climbing, we can help. High-efficiency furnaces and heat pumps can cut winter energy use substantially. We will compare operating costs for your home and help you choose equipment that pays you back month after month.',
        ],
        link: { label: 'Explore full HVAC services', path: '/heating-air-conditioning' },
      },
    ],
    faqs: [
      { q: 'Why is my furnace blowing cold air?', a: 'Common causes include a failed ignitor, a dirty flame sensor, thermostat settings, or an overheated heat exchanger tripping a safety limit. Some are simple fixes; others need a technician. If basic thermostat checks do not solve it, call us at 704-888-2411.' },
      { q: 'How long do furnaces and heat pumps last?', a: 'A well-maintained furnace typically lasts 15 to 20 years; heat pumps average 12 to 15 years because they run year-round. If your system is near the end of that range and needs an expensive repair, replacement is usually the better investment.' },
      { q: 'Is a heat pump a good choice in North Carolina?', a: 'Yes — our climate is ideal for heat pumps. Modern systems heat efficiently in our winters and provide excellent air conditioning in summer, all from one unit. Many homeowners see meaningful savings versus older electric or propane heat.' },
      { q: 'Do you offer heating maintenance plans?', a: 'Yes, we provide seasonal maintenance for heating and cooling systems. Regular service keeps efficiency high, extends equipment life, and reduces the chance of a breakdown on the coldest night of the year. Call to ask about current tune-up offers.' },
      { q: 'Can you install a furnace or heat pump in one day?', a: 'Most standard heating replacements are completed in a single day. We will confirm the timeline during your free estimate and make sure you are never left without heat longer than absolutely necessary.' },
    ],
  },

  plumbing: {
    seoTitle: 'Plumbing Services in Stanfield, NC | Residential & Commercial Plumbing',
    metaDescription: 'B.E. Holbrooks Co. provides residential and commercial plumbing services in Stanfield, Locust, Charlotte, Concord, Monroe, and nearby NC areas. Call 704-888-2411.',
    h1: 'Plumbing Services in Stanfield, NC',
    eyebrow: 'Plumbing',
    heroImage: IMAGES.plumbing,
    heroAlt: 'Plumber performing residential plumbing repair in Stanfield, NC',
    serviceName: 'Plumbing Services',
    intro: [
      'Plumbing is where B.E. Holbrooks Co. built its name. For over 60 years, our plumbers have served homes, businesses, industrial facilities, and institutions across Stanly County and the greater Charlotte area with quality workmanship and dependable service.',
      'From a leaking faucet to a complete commercial upfit, from custom homes to water line excavation, our team handles the full scope of plumbing — and because we also operate our own excavation equipment, underground line work stays under one accountable roof.',
    ],
    sections: [
      {
        h2: 'Residential Plumbing Services',
        body: [
          'Your home\'s plumbing should just work. We repair and replace fixtures, water lines, and drain lines; track down hidden leaks; solve water pressure problems; and handle the everyday repairs that keep your household running. Our plumbers treat your home with respect — clean work areas, careful workmanship, and clear communication.',
        ],
      },
      {
        h2: 'Commercial Plumbing Services',
        body: [
          'We provide plumbing for offices, retail spaces, restaurants, churches, schools, and industrial facilities. From routine repairs to complete system installations, our commercial team understands code requirements, minimizes disruption to your operation, and stands behind the work.',
        ],
      },
      {
        h2: 'Plumbing Repairs',
        body: ['No job is too small. Common repairs we handle every week include:'],
        bullets: ['Leaking pipes, fittings, and fixtures', 'Running toilets and clogged drains', 'Water heater connections and shut-off valves', 'Low water pressure diagnosis', 'Sewer and drain line problems', 'Hose bibb and outdoor faucet repair'],
      },
      {
        h2: 'New Construction Plumbing',
        body: [
          'Building new? We rough-in and finish complete plumbing systems for new construction — water supply, drain-waste-vent, gas lines, and fixtures — coordinated with your builder\'s schedule and inspected right the first time.',
        ],
      },
      {
        h2: 'Custom Home Plumbing',
        body: [
          'Custom homes deserve custom attention. We work directly with homeowners and custom builders on layouts, fixture selections, and the details — from farmhouse kitchens to spa bathrooms — that make a custom home feel finished. Six decades of experience means we have solved just about every plumbing puzzle a custom build can present.',
        ],
      },
      {
        h2: 'Commercial Shell & Upfit Plumbing',
        body: [
          'We plumb commercial shells and tenant upfits across the region. Whether you are finishing a retail bay, building out office space, or repurposing an existing building, we design and install the plumbing to fit the new use — on schedule and to code.',
        ],
      },
      {
        h2: 'Water Line & Sewer Line Support',
        body: [
          'Underground line problems are where our plumbing and excavation teams work hand in hand. We repair and replace water service lines and sewer laterals, and because we own our trenching equipment, you get one estimate, one crew, and one company accountable from the first shovel to the final connection.',
        ],
        link: { label: 'See our excavation & trenching services', path: '/excavation-trenching' },
      },
      {
        h2: 'Fixture Installation & Replacement',
        body: [
          'Upgrading a kitchen or bathroom? We install and replace faucets, sinks, toilets, tubs, showers, disposals, and hose bibbs with the care your home deserves. Our hardware and garden store at 204 West Stanly Street in Stanfield also carries a range of supplies for the do-it-yourselfer.',
        ],
      },
    ],
    faqs: [
      { q: 'Do you provide residential plumbing repair?', a: 'Yes. Residential plumbing repair is a core part of our business — leaks, clogs, fixtures, water lines, water pressure, and more. Call 704-888-2411 and we will get a plumber scheduled to your home.' },
      { q: 'Do you handle commercial plumbing?', a: 'Yes. We serve commercial, industrial, and institutional customers with repairs, maintenance, shell and upfit plumbing, and complete installations. Our 60+ year history includes decades of commercial work across the region.' },
      { q: 'Can you help with new construction plumbing?', a: 'Absolutely. We plumb new homes, commercial buildings, and additions from rough-in through final fixtures, working directly with homeowners, builders, and general contractors.' },
      { q: 'Do you work on custom homes?', a: 'Yes — custom home plumbing is a specialty. We collaborate on layout and fixture details early in the build so the finished home works as beautifully as it looks.' },
      { q: 'Do you provide plumbing estimates?', a: 'Yes. We provide clear, honest estimates for repairs, replacements, and new work. For larger projects like repipes, line replacements, or new construction, we will walk the job and provide a written estimate.' },
      { q: 'What areas do you serve for plumbing?', a: 'We provide plumbing services throughout Stanfield, Locust, Charlotte, Concord, Kannapolis, Albemarle, Norwood, Monroe, Gastonia, Huntersville, and surrounding North Carolina communities.' },
    ],
  },

  'excavation-trenching': {
    seoTitle: 'Excavation & Trenching Services in Stanfield, NC | B.E. Holbrooks Co.',
    metaDescription: 'B.E. Holbrooks Co. provides excavation and trenching services for plumbing, water lines, sewer lines, and site work in Stanfield, NC and nearby areas.',
    h1: 'Excavation & Trenching Services in Stanfield, NC',
    eyebrow: 'Excavation & Trenching',
    heroImage: IMAGES.excavation,
    heroAlt: 'Excavation and trenching equipment digging for water line installation in Stanfield, NC',
    serviceName: 'Excavation & Trenching',
    intro: [
      'Underground work demands the right equipment and the right experience. B.E. Holbrooks Co. provides excavation and trenching services across Stanfield and surrounding communities — and because excavation goes hand in hand with our plumbing work, we deliver complete underground solutions under one roof.',
      'From water and sewer line trenches to residential and commercial site work, our operators dig carefully, safely, and with respect for your property.',
    ],
    sections: [
      {
        h2: 'Excavation for Plumbing Projects',
        body: [
          'When a water line breaks or a sewer lateral fails, the repair starts below ground. Our excavation crew opens the trench, our plumbers make the repair, and we backfill and clean up — one company, one schedule, one accountable team from start to finish.',
        ],
      },
      {
        h2: 'Trenching for Underground Utilities',
        body: [
          'We dig clean, properly sloped trenches for water lines, sewer lines, and other underground utilities on residential and commercial properties. Careful trenching protects existing utilities, prevents settling, and sets up the plumbing work for decades of trouble-free service.',
        ],
        bullets: ['Water service line trenches', 'Sewer lateral trenches', 'Utility trenching for new construction', 'Careful work around existing lines and landscaping'],
      },
      {
        h2: 'Water Line & Sewer Line Support',
        body: [
          'A failing water or sewer line is stressful enough without juggling multiple contractors. We locate the problem, excavate the line, complete the plumbing repair or replacement, and restore the site. If you have soggy spots in the yard, unexplained water bills, or recurring drain problems, call 704-888-2411 for an evaluation.',
        ],
        link: { label: 'Learn about our plumbing services', path: '/plumbing' },
      },
      {
        h2: 'Residential Excavation',
        body: [
          'For homeowners, we handle excavation for line replacements, new service connections, drainage improvements, and small site projects. We work carefully around lawns, driveways, and landscaping, and we leave the site neat when the job is done.',
        ],
      },
      {
        h2: 'Commercial Excavation',
        body: [
          'Our commercial excavation services support plumbing installations, utility work, and site preparation for commercial buildings, upfits, and new construction across Stanly County and the greater Charlotte area.',
        ],
      },
      {
        h2: 'Why Excavation and Plumbing Work Together',
        body: [
          'Most underground plumbing projects stall at the handoff between the excavator and the plumber. At B.E. Holbrooks Co., there is no handoff. The same company that digs the trench installs the pipe, pressure-tests the line, and stands behind all of it — which means faster timelines, fewer surprises, and one call if you ever need us again.',
        ],
      },
    ],
    faqs: [
      { q: 'Do you excavate for water line replacement?', a: 'Yes. Water line excavation and replacement is one of our most common projects. We handle the digging, the plumbing, and the site restoration as one coordinated job.' },
      { q: 'Can you trench for sewer line repairs?', a: 'Yes. We excavate and trench for sewer lateral repairs and replacements, then our licensed plumbers complete the line work to code.' },
      { q: 'Do you serve areas outside Stanfield?', a: 'Yes. We provide excavation and trenching throughout Stanly County and the surrounding region, including Locust, Albemarle, Norwood, Concord, Kannapolis, Monroe, and the greater Charlotte area.' },
      { q: 'How do I get an excavation estimate?', a: 'Call 704-888-2411 or request an estimate through our contact form. For most projects we will visit the site, assess access and scope, and provide a clear written estimate.' },
    ],
  },

  'indoor-air-quality': {
    seoTitle: 'Indoor Air Quality Services in Stanfield, NC | B.E. Holbrooks Co.',
    metaDescription: 'Improve comfort with indoor air quality solutions from B.E. Holbrooks Co. Serving Stanfield, Locust, Charlotte, Concord, Monroe, and surrounding NC communities.',
    h1: 'Indoor Air Quality Services in Stanfield, NC',
    eyebrow: 'Indoor Air Quality',
    heroImage: IMAGES.acRepair,
    heroAlt: 'Indoor air quality and whole-home comfort solutions in Stanfield, NC',
    serviceName: 'Indoor Air Quality',
    intro: [
      'The air inside your home can be more polluted than the air outside — and your family breathes it all day, every day. B.E. Holbrooks Co. helps homeowners across Stanfield and the surrounding area breathe easier with whole-home indoor air quality solutions integrated directly into your HVAC system.',
      'From humidity control to advanced air purification, we evaluate your home\'s air and recommend practical solutions that fit your family\'s needs and budget.',
    ],
    sections: [
      {
        h2: 'Whole-Home Comfort',
        body: [
          'True comfort is more than the number on the thermostat. Humidity, airborne particles, allergens, and stale air all affect how your home feels and how your family feels in it. Our whole-home approach treats the air itself — not just the temperature.',
        ],
      },
      {
        h2: 'Humidity Control',
        body: [
          'Carolina summers are humid, and excess indoor humidity makes your home feel warmer, encourages mold growth, and aggravates allergies. Whole-home dehumidification integrated with your HVAC system keeps humidity in the healthy 40-50% range automatically, all summer long.',
        ],
      },
      {
        h2: 'Air Purification',
        body: [
          'Whole-home air purifiers work inside your duct system to reduce airborne particles, allergens, odors, and microbes throughout the entire house — far beyond what a portable room unit can do. We install proven purification systems and explain exactly what each one does and does not do. Ask about current air purifier promotions when you call.',
        ],
        link: { label: 'See current promotions', path: '/promotions' },
      },
      {
        h2: 'Filtration Upgrades',
        body: [
          'The filter in your system is your first line of defense. We help you choose the right filtration level for your system and your family — including high-MERV media filters that capture fine dust, pollen, and pet dander without restricting airflow.',
        ],
      },
      {
        h2: 'HVAC System Improvements',
        body: [
          'Sometimes the air quality fix is the system itself: sealing leaky ducts that pull in attic or crawlspace air, correcting airflow imbalances, or replacing an aging system that circulates dust. We evaluate the whole picture before recommending anything.',
        ],
        link: { label: 'Explore heating & air services', path: '/heating-air-conditioning' },
      },
      {
        h2: 'IAQ Benefits for Homeowners',
        body: ['Families who invest in indoor air quality commonly notice:'],
        bullets: ['Fewer allergy and asthma triggers indoors', 'Less dust settling on furniture', 'Reduced musty odors and humidity', 'Better sleep and overall comfort', 'A cleaner, more efficient HVAC system'],
      },
    ],
    faqs: [
      { q: 'How do I know if my home has an air quality problem?', a: 'Common signs include persistent dust, musty odors, allergy symptoms that improve when you leave the house, condensation on windows, and uneven humidity. Schedule a consultation and we will evaluate your home\'s air and HVAC system together.' },
      { q: 'Is a whole-home air purifier worth it?', a: 'For families with allergies, asthma, pets, or respiratory sensitivities, whole-home purification typically delivers a noticeable improvement because it treats all the air moving through your system — not just one room.' },
      { q: 'Can my HVAC system control humidity?', a: 'A properly sized air conditioner removes some humidity, but in our climate it often is not enough. A whole-home dehumidifier integrates with your existing system and controls humidity independently for consistent comfort.' },
      { q: 'Do you offer indoor air quality consultations?', a: 'Yes. Call 704-888-2411 or request a consultation online. We will inspect your system, discuss your concerns, and recommend practical options at clear prices.' },
    ],
  },

  financing: {
    seoTitle: 'HVAC Financing in Stanfield, NC | B.E. Holbrooks Co.',
    metaDescription: 'Explore financing options for HVAC replacement and comfort upgrades with B.E. Holbrooks Co. in Stanfield, NC. Call 704-888-2411 to learn more.',
    h1: 'HVAC Financing Options',
    applyUrl: 'https://retailservices.wellsfargo.com/ahapp/init-app?m=0024119851&l=en_US',
    eyebrow: 'Financing',
    heroImage: IMAGES.rooftopAc,
    heroAlt: 'HVAC financing options for heating and air conditioning replacement in Stanfield, NC',
    serviceName: 'HVAC Financing',
    intro: [
      'A new heating and air conditioning system is an investment in your home\'s comfort, efficiency, and value — but it should not have to wait because of the upfront cost. B.E. Holbrooks Co. offers financing options that help qualified homeowners spread the investment into manageable monthly payments.',
      'Whether you are replacing a failed system in an emergency or planning a comfort upgrade, talk with our team about the financing options currently available.',
    ],
    sections: [
      {
        h2: 'Financing for HVAC Replacement',
        body: [
          'When an old system fails, you rarely get to pick the timing. Financing lets you restore comfort now — with a new high-efficiency American Standard system — and pay over time instead of draining savings or settling for a short-term patch on dying equipment.',
        ],
      },
      {
        h2: 'Financing for Comfort Upgrades',
        body: [
          'Planning ahead? Financing also works for proactive upgrades: replacing an aging system before it fails, adding a high-efficiency heat pump, or improving your home with indoor air quality solutions. Many homeowners find the monthly payment is substantially offset by lower energy bills.',
        ],
      },
      {
        h2: 'How Financing Helps Homeowners',
        body: ['Financing your comfort system offers real advantages:'],
        bullets: ['Restore or upgrade comfort without a large upfront payment', 'Manageable monthly payments that fit your budget', 'Energy savings from efficient equipment help offset the payment', 'Avoid pouring repair money into a system near the end of its life', 'Get the right system for your home instead of the cheapest stopgap'],
      },
      {
        h2: 'Request a Quote',
        body: [
          'Every financing conversation starts with a free, no-pressure estimate. We will evaluate your home, present system options at different price points, and review the financing terms currently available so you can decide with complete information.',
        ],
        link: { label: 'Request your free estimate', path: '/contact' },
      },
    ],
    faqs: [
      { q: 'Do you offer financing on new HVAC systems?', a: 'Yes, financing is available for qualified homeowners on system replacement and installation. Options and terms change over time, so call 704-888-2411 and we will explain what is currently available.' },
      { q: 'Can I finance AC and heating replacement together?', a: 'Yes. Complete system replacements — heating and cooling together — are the most common financed projects and often deliver the best efficiency gains per dollar.' },
      { q: 'How do I apply?', a: 'Start with a free estimate. Once you choose your system, our team will walk you through the simple financing application process and answer any questions about terms and payments.' },
      { q: 'Are there rebates or promotions I can combine with financing?', a: 'Often, yes. Manufacturer rebates, utility incentives, and our seasonal promotions can frequently be combined with financing. Ask about current offers when you call.' },
    ],
  },

  promotions: {
    seoTitle: 'HVAC Promotions & Rebates in Stanfield, NC | B.E. Holbrooks Co.',
    metaDescription: 'View current HVAC promotions, tune-up offers, air purifier discounts, and rebates from B.E. Holbrooks Co. in Stanfield, NC.',
    h1: 'Current HVAC Promotions & Rebates',
    eyebrow: 'Promotions',
    heroImage: IMAGES.heroTech,
    heroAlt: 'Current HVAC promotions, tune-up specials and rebates in Stanfield, NC',
    serviceName: 'Promotions & Rebates',
    intro: [
      'B.E. Holbrooks Co. regularly offers seasonal promotions, tune-up specials, and manufacturer rebates to help our neighbors save on comfort. Offers change throughout the year, so call 704-888-2411 to hear what is available right now.',
    ],
    sections: [
      {
        h2: 'Heating System Tune-Ups',
        body: [
          'Before the cold arrives, get your heating system inspected, cleaned, and tuned by a trained technician. Seasonal tune-up specials make it affordable to protect your family from a mid-winter breakdown — and a tuned system costs less to run all season.',
        ],
      },
      {
        h2: 'Air Purifier Discounts',
        body: [
          'Breathe easier for less. We periodically offer discounts on whole-home air purification systems installed with your existing HVAC equipment. If allergies, dust, or odors are a concern in your home, ask about current air purifier offers when you call.',
        ],
        link: { label: 'Learn about indoor air quality', path: '/indoor-air-quality' },
      },
      {
        h2: 'HVAC Rebates',
        body: [
          'High-efficiency American Standard systems frequently qualify for manufacturer rebates, and utility incentives may apply as well. We stay current on available rebate programs and will help you claim every dollar your new system qualifies for.',
        ],
        link: { label: 'Explore AC replacement options', path: '/air-conditioning-installation-stanfield-nc' },
      },
      {
        h2: 'Seasonal Promotions',
        body: [
          'Watch for spring air conditioning specials, fall heating tune-up offers, and system replacement promotions throughout the year. The fastest way to hear about current offers is to call us at 704-888-2411 — our team will always tell you what promotions apply to your job.',
        ],
      },
    ],
    faqs: [
      { q: 'What promotions are available right now?', a: 'Offers change seasonally. Call 704-888-2411 and our team will share the current tune-up specials, equipment promotions, and rebates available for your project.' },
      { q: 'Can I combine a promotion with financing?', a: 'In many cases, yes. Manufacturer rebates and our promotional pricing can often be combined with financing for qualified homeowners. We will lay out all the options during your free estimate.' },
      { q: 'Do promotions apply to both heating and air conditioning?', a: 'Most seasonal offers focus on the upcoming season — cooling promotions in spring, heating promotions in fall — but system replacement offers typically cover both. Call for current details.' },
    ],
  },
};
